module.exports = __webpack_public_path__ + "img/facesheet.720d8368.svg";